import { types, actions } from './requests'
export const MERGEKIT_TYPES = {
    ...types('MERGEKIT'),
}
export const MERGEKIT_ACTIONS = {
    ...actions('MERGEKIT'),
}